export module MojoWellKnownNames {

  export class AddOnCodes {
    static WS003_FormsApprovalHandling: string = "WS003";
    static WS004_Mci: string = "WS004";
    static WS005_Mfs: string = "WS005";
    static WS006_Mft: string = "WS006";
    static WS007_Works: string = "WS007";
  }

  export class RoleIds {
    static SystemAdministrator: string = 'system_administrator';
    static SupplierAdministrator: string = 'supplier_administrator';
    static SupplierUser: string = 'supplier_user';
    static ClientAdministrator: string = 'client_administrator';
    static SupplierSeniorUser: string = 'supplier_senior_user';
    static ClientSeniorUser: string = 'client_senior_user';
    static User: string = 'user';
    static TenantAdministrator: string = 'tenant_administrator';
    static TenantUser: string = 'tenant_user';
    static TenantSeniorUser: string = 'tenant_senior_user';
    static OccupantUser: string = 'occupant_user';
  }
}

export module MojoWellKnownNames {
  export class Products {
    static MojoDashboard: Product = 'mojopma';
    static Mci: Product = 'mci';
    static MojoForSuppliers: Product = 'mojo_for_suppliers';
    static MojoForTenants: Product = 'mojo_for_tenants';
  }

  export type Product =
    | 'mojopma'
    | 'mci'
    | 'mojo_for_suppliers'
    | 'mojo_for_tenants';

}

export module MojoWellKnownNames {
  export class RoleNames {
    static AnyAdministrator: string = 'Administrator';
    static SystemAdministrator: string = 'System Administrator';
    static SupplierAdministrator: string = 'Supplier Administrator';
    static SupplierUser: string = 'Supplier User';
    static ClientAdministrator: string = 'Client Administrator';
    static User: string = 'Client User';
    static Previewer: string = 'Previewer';
    static SupplierSeniorUser: string = "Supplier User with Upload";
    static ClientSeniorUser: string = "Client User with Upload";

    static TenantAdministrator: string = 'Tenant Administrator';
    static TenantUser: string = 'Tenant User';
    static TenantSeniorUser: string = "Tenant User with Upload";
    static OccupantUser: string = "Occupant";
  }
}

export module MojoWellKnownNames {
  export class PermissionNames {
    static UploadPropertyPictures: string = "UploadPropertyPictures";

    static UploadDocuments: string = "UploadDocuments";

    static EditDocumentCenterMetaData: string = "EditDocumentCenterMetaData";

    static PreviewProducts: string = "PreviewProducts";

    static AdministerForms: string = "AdministerForms";

    static AdministerWidgets: string = "AdministerWidgets";

    static AdministerUsers: string = "AdministerUsers";
  }
}

export module MojoWellKnownNames {
  export class PmaPermissions {
    static FormsAdministrator: string = 'OnlineFormAdministrator';
  }
}

export module MojoWellKnownNames {
  export class ClaimTypeNames {
    static ClientRef: string = 'ClientRef';
    static ClientParentRef: string = 'ClientParentRef';
  }
}

export module MojoWellKnownNames {
  export class Platforms {
    static Mci: string = 'mci';
  }
}

export module MojoWellKnownNames {
  export class DetailsViewNames {
    static Lease: string = 'Lease';
  }
}
